import React from 'react';
import { FormControl, TextField } from '@mui/material';
import { FieldParam } from '../types';
import useClasses from '../../utils/useClasses';

// Style const
const styles = () => ({
  container: {
    display: 'flex',
    marginBottom: '10px',
  },
  label: {
    fontWeight: 'bold',
  },
});
type Param = Omit<FieldParam, 'renderer' | 'key'> 
interface Props {
  param: Param;
  selected?: string | number;
  onChange: (value: string | number) => void;
}

export function InputFieldRenderer(props: Props) {
  const classes = useClasses(styles);
  const { param, selected, onChange } = props;
  const { name, defaultValue} = param;
  // const globaltheme = useTheme();
  // const theme = useMemo(() => {
  //   return createTheme({
  //     components: {

  //       MuiOutlinedInput: {
  //         styleOverrides: {
  //           input: {
  //             color: globaltheme.palette.text.primary,
  //           },
  //           notchedOutline: {
  //             border: 'none',
  //             paddingRight: 0,
  //           },
  //         },
  //       },
  //       MuiInputLabel: {
  //         styleOverrides: {
  //           root: {
  //             top: '7px',
  //           },
  //           shrink: {
  //             top: '0px',
  //           },
  //         },
  //       },
  //     },
  //   });
  // }, [ globaltheme]);

  const isOffsetField = name === 'Offset';
  const onInputChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.value);
    },
    [onChange],
  );

  const onKeyDown = React.useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (isOffsetField && event.key === "-") {
        event.preventDefault(); // Prevent "-" from being entered
        onChange(0); // Set value to 0
      }
    },
    [onChange, isOffsetField]
  );

  return (
    <div className={classes.container}>
      <FormControl variant="outlined" size={'small'}>
        <TextField
          type={param.type}
          label={name}
          variant="outlined"
          onChange={onInputChange}
          onKeyDown={onKeyDown}
          defaultValue={selected || defaultValue}
          size={'small'}
          inputProps={{
            min: isOffsetField ? 0 : undefined,
          }}
        />
      </FormControl>
    </div>
  );
}
